import React, { Fragment, FunctionComponent } from 'react';
import style from './UploaderField.module.scss';
import { translate } from './UploaderField.translations';
import { FieldValidatorType, FieldWrapper } from '@progress/kendo-react-form';
import { BrassField, BrassFieldProps } from '../Field';
import { BrassUploader, BrassUploaderProps } from '../../../';
import { BrassError } from '../../../labels/Error';
import { BrassLoader } from '../../../indicators';
import { requiredValidator } from '../validators/required';
import { I18nService } from '../../../../../services';
import { Label } from '@progress/kendo-react-labels';

interface UploaderFieldInputProps extends BrassUploaderProps {
  value?: string;
  visited: boolean;
  maxLength?: number;
  iconClass?: string;
  disabled?: boolean;
}

const UploaderFieldInput: FunctionComponent<UploaderFieldInputProps> = (
  fieldRenderProps: any,
): any => {
  const { validationMessage, disabled, visited } = fieldRenderProps;
  return (
    <Fragment>
      <BrassUploader {...fieldRenderProps} disabled={disabled} />
      {visited && validationMessage && <BrassError>{validationMessage}</BrassError>}
    </Fragment>
  );
};

interface BrassUploaderFieldProps
  extends Omit<BrassFieldProps & UploaderFieldInputProps, 'valid,component'> {
  name?: string;
  label?: string;
  loading?: boolean;
  disabled?: boolean;
  iconClass?: string;
  validator?: FieldValidatorType[];
}

const BrassUploaderField: FunctionComponent<BrassUploaderFieldProps> = (
  props: any,
) => {
  const { name, required, loading, validator } = props;

  const validators = validator && validator.length ? [...validator] : [];
  if (required) {
    validators.push(requiredValidator);
  }

  if (loading) {
    return (
      <BrassField
        {...props}
        disabled
        name={name!}
        component={BrassUploader}
        defaultValue={translate('loadingData')}
      />
    );
  }

  return (
    <FieldWrapper>
      <Label style={{ opacity: 0.6 }}>
        {required ? `${props.label}*` : props.label}
      </Label>
      <BrassField
        {...props}
        name={name!}
        validator={validators}
        component={loading ? () => <BrassLoader /> : UploaderFieldInput}
        label={undefined /* required ? `${props.label}*` : props.label */}
      />
    </FieldWrapper>
  );
};

export { BrassUploaderField };
export type { BrassUploaderFieldProps };
